import { UI, Stack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableHeadContainer, TableHeadItem } from '../../../../../../../../components/TableHead';
import { tableHeadPrivatePensionSecondCopy } from '../../constants';

export interface SecondCopyListHeaderProps {
  handleCheckAll: () => void;
  selected: boolean;
}

export const SecondCopyListHeader: React.FC<SecondCopyListHeaderProps> = ({
  selected,
  handleCheckAll,
}) => {
  const tableHeadPrivatePensionSecondCopyFiltered = tableHeadPrivatePensionSecondCopy.slice(1);

  return (
    <TableHeadContainer px={Spacing['inline.xxxs']} alignItems="center">
      <Stack {...tableHeadPrivatePensionSecondCopy[0]}>
        <UI.Checkbox
          testId="second-copy-checkbox-all"
          onChange={() => handleCheckAll()}
          options={[{ label: '', value: 'all' }]}
          selectedValues={selected ? ['all'] : []}
          optionPadding={{ bottom: 0, right: 0 }}
          customProps={{ backgroundColor: 'transparent' }}
        />
      </Stack>
      {tableHeadPrivatePensionSecondCopyFiltered.map((item, index) => (
        <TableHeadItem key={`${item.title}-${index}`} {...item} value={item.orderValue} />
      ))}
    </TableHeadContainer>
  );
};
